document.addEventListener("DOMContentLoaded", function () {
	function initArticlePins() {
		var articleRoot = document.querySelector(".js-journal-article")
		if (!articleRoot) return

		var pinImages = articleRoot.querySelectorAll(
			".js-journal-article-pin-image"
		)
		pinImages.forEach(function (img) {
			var pin = img.querySelector(".js-journal-article-pin")
			var closer = img.querySelector(".js-journal-article-pin-product-close")
			if (pin && img.dataset.pinOpen === "true") {
				img.classList.add("is-active")
			}

			if (pin) {
				pin.addEventListener("click", function (e) {
					img.classList.toggle("is-active")
				})
			}

			if (closer) {
				closer.addEventListener("click", function (e) {
					img.classList.remove("is-active")
				})
			}
		})
	}

	function initCarousel(carousel) {
		var carouselViewport = carousel.querySelector(
			".js-vhorizontal-carousel-viewport"
		)
		var carouselPrev = carousel.querySelector(".js-vhorizontal-carousel-prev")
		var carouselNext = carousel.querySelector(".js-vhorizontal-carousel-next")
		var instance = EmblaCarousel(carouselViewport, {
			align: "start",
		})

		if (carouselPrev) {
			carouselPrev.addEventListener("click", () => {
				instance.scrollPrev()
			})
		}

		if (carouselNext) {
			carouselNext.addEventListener("click", () => {
				instance.scrollNext()
			})
		}

		return instance
	}

	function initCarousels() {
		var articleRoot = document.querySelector(".js-journal-article")
		if (!articleRoot) return
		var articleCarousels = articleRoot.querySelectorAll(
			".js-vhorizontal-carousel"
		)

		if (articleCarousels.length) {
			var instances = []

			for (let i = 0; i < articleCarousels.length; i++) {
				var articleInstance = initCarousel(articleCarousels[i])
				instances.push(articleInstance)
			}
		}
	}

	initArticlePins()
	initCarousels()
})
